import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { TextLink, Icon } from '../../../../design-system';
import { SYS_COLOR_FOREGROUND_ON_FORMFIELDS_SUBDUED_DARK } from '@oneaudi/unified-web-alpha-common-v2';
import {
  ZipInputWrapper,
  InputWrapper,
  TextInputField,
  DeleteInputIcon,
  Description,
  BackToNationalWrapper,
  SubmitLinkWrapper,
} from './ZipInput.styles';
import BackIcon from '../../../assets/icons/BackIcon';
import useZipInput from '../../../hooks/useZipInput';

const ZipInputAlpha: React.FC = () => {
  const { t } = useTranslation();
  const formRef = useRef<HTMLFormElement>(null);
  const { inputValue, isNatPage, setInputValue, handleClearZipCta, handleKeyDown, handleSubmit } =
    useZipInput();

  return (
    <ZipInputWrapper ref={formRef} onSubmit={handleSubmit} data-cy="zip-input-form">
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', flex: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <InputWrapper data-cy="zip-input-wrapper">
            <span style={{ color: SYS_COLOR_FOREGROUND_ON_FORMFIELDS_SUBDUED_DARK }}>
              <Icon name="search" size="s" />
            </span>
            <TextInputField
              placeholder={t('promo.filters.zipSearch.placeholder')}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              data-testid="zip-input-field"
            />
            {inputValue.length ? (
              <DeleteInputIcon onClick={() => setInputValue('')} aria-label="Clear zip code">
                <Icon name="cancel" size="s" />
              </DeleteInputIcon>
            ) : null}
          </InputWrapper>
          {isNatPage ? (
            <Description>{t('promo.filters.zipSearch.description')}</Description>
          ) : (
            <BackToNationalWrapper>
              <TextLink variant="standalone" size="sm" onClick={handleClearZipCta}>
                <BackIcon color="currentColor" />
                {t('promo.filters.zipSearch.returnNational')}
              </TextLink>
            </BackToNationalWrapper>
          )}
        </div>
        <SubmitLinkWrapper style={{ paddingTop: '12px' }}>
          <TextLink
            size="md"
            variant="standalone"
            onClick={() => formRef.current?.requestSubmit()}
            data-testid="find-my-offers-cta"
          >
            {t('promo.filters.zipSearch.submit')}
          </TextLink>
        </SubmitLinkWrapper>
      </div>
    </ZipInputWrapper>
  );
};

export default ZipInputAlpha;
